import { useTheme } from "./ThemeContext";
import { useEffect, useState } from "react";
import { ReactComponent as ArrowLeftIcon } from "./assets/icons/arrowLeft.svg"; // اگر خواستی چپ باشه
import styles from "./components/Profile/ProfileMenuList.module.css"; // چون می‌خوای با menuItem یکی باشه

import { ReactComponent as SunIcon } from "./assets/icons/theme-light-sun.svg"
import { ReactComponent as MoonIcon } from "./assets/icons/theme-dark-moon.svg"


const ThemeToggleButton = () => {
  const { toggleTheme, isDarkMode } = useTheme();
  const [currentTheme, setCurrentTheme] = useState(isDarkMode);

  useEffect(() => {
    setCurrentTheme(isDarkMode);
  }, [isDarkMode]);

  return (
    <div
      className={styles.menuItem}
      style={{ cursor: "pointer" }}
      onClick={() => {
        toggleTheme();
        setCurrentTheme((prev) => !prev);
      }}
    >
      <div className={styles.chevronContainer}>
        <ArrowLeftIcon className={styles.chevronIcon} />
      </div>
      <p className={styles.menuText}>{currentTheme ? "تم روز" : "تم شب"}</p>
      <div className={styles.iconContainer}>
        {currentTheme ? <SunIcon /> : <MoonIcon />}
      </div>
    </div>
  );
};

export default ThemeToggleButton;
